import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">401</h1>
      <p className="text-xl text-gray-700 mb-2">Unauthorized Access</p>
      <p className="text-md text-gray-600 mb-6">
        You don't have permission to view this page.
      </p>
      <button
        onClick={() => navigate(-2)}
        className="bg-gray-700 hover:bg-gray-600 text-white py-2 px-4 rounded"
      >
        Go Back
      </button>
    </div>
  );
};

export default Unauthorized;
